import { Component } from '@angular/core';
import { GeneralButtonsComponent } from '../general-buttons/general-buttons.component';
import { CommonModule } from '@angular/common';
import { AccionesRapidasButtonsComponent } from '../quick-actions-buttons/quick-actions-buttons.component';

@Component({
  selector: 'app-tarjetas-sidebar',
  standalone: true,
  imports: [GeneralButtonsComponent, AccionesRapidasButtonsComponent], // Add these to imports
  templateUrl: './cards-sidebar.component.html',
  styleUrl: './cards-sidebar.component.scss',
})
export class TarjetasSidebarComponent {
  // ...existing code...
}
